import type { CustomerContact } from '@clockwise/clients/customer-contacts';

/** Human-readable labels for a contact's `contactType`. Shared by the contacts
 *  list panel and the contact view sheet so the two can't drift. */
export const CONTACT_TYPE_LABELS: Record<NonNullable<CustomerContact['contactType']>, string> = {
  billing: 'Billing',
  alternate: 'Alternate',
};

/** Display name for a contact: "Preferred (First Last)" when a preferred name
 *  is set, otherwise "First Last". */
export function contactName(c: CustomerContact): string {
  const full = `${c.firstName} ${c.lastName}`.trim();
  return c.preferredName ? `${c.preferredName} (${full})` : full;
}
